/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  const isSecure = window.location.protocol === 'https:';
  const sameSite = isSecure ? 'SameSite=None; Secure' : 'SameSite=Lax';

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; ${sameSite}`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return decodeURIComponent(cookies.pop().split(';').shift());
  }

  return null;
}

/* global Modal, Shopify */

if (!customElements.get('age-verification-pop-up')) {
  customElements.whenDefined('modal-dialog')
    .then(() => {
      class AgeVerificationPopUp extends Modal {
        constructor() {
          super();

          this.cookie = this.id ? `${this.id}-dismissed` : 'age-verification-dismissed';
          this.cancelButton = this.querySelector('.js-cancel-button');
          this.cancelMessage = this.querySelector('.js-cancel-message');

          this.boundHandleCancelClick = this.handleCancelClick.bind(this);
          this.boundHandleSectionSelect = this.handleSectionSelect.bind(this);
          this.boundClose = this.close.bind(this);

          if (this.cancelButton) {
            this.cancelButton.addEventListener('click', this.boundHandleCancelClick);
          }

          if (typeof Shopify !== 'undefined' && Shopify.designMode) {
            document.addEventListener('shopify:section:select', this.boundHandleSectionSelect);
            document.addEventListener('shopify:section:deselect', this.boundClose);
          } else if (!getCookie(this.cookie)) {
            this.open();
          }
        }

        disconnectedCallback() {
          if (super.disconnectedCallback) {
            super.disconnectedCallback();
          }

          if (this.cancelButton) {
            this.cancelButton.removeEventListener('click', this.boundHandleCancelClick);
          }

          if (typeof Shopify !== 'undefined' && Shopify.designMode) {
            document.removeEventListener('shopify:section:select', this.boundHandleSectionSelect);
            document.removeEventListener('shopify:section:deselect', this.boundClose);
          }
        }

        handleSectionSelect(evt) {
          if (evt.target === this.closest('.shopify-section')) {
            this.open();
          }
        }

        open(opener) {
          super.open(opener);

          if (this.keyupHandler) {
            this.removeEventListener('keyup', this.keyupHandler);
          }
        }

        handleCancelClick() {
          if (this.cancelMessage) {
            this.cancelMessage.removeAttribute('hidden');
          }
        }

        handleClick(evt) {
          if (evt.target.matches('.js-close-modal')) {
            super.handleClick(evt);
            setCookie(this.cookie, 'true', 3650);
          }
        }
      }

      customElements.define('age-verification-pop-up', AgeVerificationPopUp);
    })
    .catch((err) => {
      console.error('Failed to define age-verification-pop-up:', err);
    });
}